import { render, staticRenderFns } from "./AboutWotive.vue?vue&type=template&id=21b28eaa&scoped=true"
import script from "./AboutWotive.vue?vue&type=script&lang=js"
export * from "./AboutWotive.vue?vue&type=script&lang=js"
import style0 from "./AboutWotive.vue?vue&type=style&index=0&id=21b28eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b28eaa",
  null
  
)

export default component.exports